import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Briefcase, MapPin, Clock, ArrowRight } from 'lucide-react';
export function CareersPage() {
  const openings = [{
    id: 1,
    title: 'Senior Full Stack Engineer',
    department: 'Engineering',
    location: 'Pune / Remote',
    type: 'Full-time',
    description: "Build scalable features for India's leading plot transaction platform."
  }, {
    id: 2,
    title: 'Product Manager',
    department: 'Product',
    location: 'Pune',
    type: 'Full-time',
    description: 'Drive product strategy and roadmap for our core marketplace.'
  }, {
    id: 3,
    title: 'Legal Compliance Manager',
    department: 'Legal',
    location: 'Mumbai / Pune',
    type: 'Full-time',
    description: 'Ensure RERA compliance and manage legal documentation processes.'
  }, {
    id: 4,
    title: 'UX Designer',
    department: 'Design',
    location: 'Remote',
    type: 'Full-time',
    description: 'Design intuitive experiences for complex real estate workflows.'
  }];
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-3204">
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-3205">
        <Link to="/" className="flex items-center gap-2" data-id="element-3206">
          <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-3207"></div>
          <span className="font-bold text-xl tracking-tight" data-id="element-3208">
            Citiplots.com
          </span>
        </Link>
      </header>

      <main className="flex-1 max-w-6xl mx-auto px-6 py-12" data-id="element-3209">
        <h1 className="text-4xl font-bold mb-4" data-id="element-3210">Careers at Citiplots</h1>
        <p className="text-lg text-gray-500 mb-12 font-mono" data-id="element-3211">
          Join us in transforming India's real estate market
        </p>

        {/* Why Join Us */}
        <div className="bg-white border border-gray-300 p-8 mb-8" data-id="element-3212">
          <h2 className="text-2xl font-bold mb-6" data-id="element-3213">Why Work With Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3214">
            <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-3215">
              <h3 className="font-bold mb-2" data-id="element-3216">Impact</h3>
              <p className="text-sm text-gray-600" data-id="element-3217">
                Work on products that directly impact millions of Indians
                looking to own land.
              </p>
            </div>
            <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-3218">
              <h3 className="font-bold mb-2" data-id="element-3219">Growth</h3>
              <p className="text-sm text-gray-600" data-id="element-3220">
                Fast-paced environment with opportunities to learn and grow your
                career.
              </p>
            </div>
            <div className="p-4 border border-gray-200 bg-gray-50" data-id="element-3221">
              <h3 className="font-bold mb-2" data-id="element-3222">Culture</h3>
              <p className="text-sm text-gray-600" data-id="element-3223">
                Transparent, collaborative culture that values innovation and
                ownership.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div className="bg-white border border-gray-300 p-8 mb-8" data-id="element-3224">
          <h2 className="text-2xl font-bold mb-6" data-id="element-3225">Benefits & Perks</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3226">
            {['Competitive salary with equity options', 'Health insurance for you and family', 'Flexible work from home policy', 'Learning & development budget', 'Unlimited sick leave', 'Quarterly team offsites', 'Latest tech equipment', 'Gym membership reimbursement'].map((benefit, i) => <div key={i} className="flex items-center gap-2" data-id="element-3227">
                <div className="w-2 h-2 bg-[#1f2933] rounded-full" data-id="element-3228"></div>
                <span className="text-sm text-gray-700" data-id="element-3229">{benefit}</span>
              </div>)}
          </div>
        </div>

        {/* Open Positions */}
        <div className="bg-white border border-gray-300 p-8" data-id="element-3230">
          <h2 className="text-2xl font-bold mb-6" data-id="element-3231">Open Positions</h2>
          <div className="space-y-4" data-id="element-3232">
            {openings.map(job => <div key={job.id} className="border border-gray-300 p-6 hover:bg-gray-50 transition-colors" data-id="element-3233">
                <div className="flex items-start justify-between mb-3" data-id="element-3234">
                  <div data-id="element-3235">
                    <h3 className="font-bold text-lg mb-1" data-id="element-3236">{job.title}</h3>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-3237">
                      {job.description}
                    </p>
                  </div>
                  <button className="px-4 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800 flex items-center gap-2" data-id="element-3238">
                    Apply <ArrowRight className="w-4 h-4" data-id="element-3239" />
                  </button>
                </div>
                <div className="flex flex-wrap gap-4 text-xs text-gray-500" data-id="element-3240">
                  <span className="flex items-center gap-1" data-id="element-3241">
                    <Briefcase className="w-3 h-3" data-id="element-3242" />
                    {job.department}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-3243">
                    <MapPin className="w-3 h-3" data-id="element-3244" />
                    {job.location}
                  </span>
                  <span className="flex items-center gap-1" data-id="element-3245">
                    <Clock className="w-3 h-3" data-id="element-3246" />
                    {job.type}
                  </span>
                </div>
              </div>)}
          </div>

          <div className="mt-8 p-6 bg-gray-50 border border-gray-200 text-center" data-id="element-3247">
            <p className="text-sm text-gray-600 mb-4" data-id="element-3248">
              Don't see a role that fits? We're always looking for talented
              people.
            </p>
            <button className="px-6 py-2 border border-gray-300 text-sm font-bold hover:bg-white" data-id="element-3249">
              Send Us Your Resume
            </button>
          </div>
        </div>
      </main>

      <Footer data-id="element-3250" />
    </div>;
}